// hooks/useBaseMutation.ts
import { UseMutationOptions, useMutation, UseMutationResult } from '@tanstack/react-query';

export function useBaseMutation<TData, TVariables, TError = Error>(
    mutationFn: (variables: TVariables) => Promise<TData>,
    options?: Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>
): UseMutationResult<TData, TError, TVariables> {
    return useMutation<TData, TError, TVariables>({
        mutationFn,
        ...options,
    });
}